import { OwnershipFilterTypes } from "store/auth/auth.types";
const state = {
    items: [],
    loading: false,
    searchQuery: "",
    tagsFilters: {
        included: [],
        excluded: [],
    },
    sortingDirections: {
        name: null,
        lastUsed: "desc",
    },
    ownershipFilter: OwnershipFilterTypes.All,
    parsedData: null,
};
export default state;
